export const DIAGNOSTIC_ORDER_ACTIONS = {
  'INIT_DIAGNOSTIC_ORDER_CONFIG': 'DIAGNOSTIC_ORDER_INIT_DIAGNOSTIC_ORDER_CONFIG',
  'INIT_DIAGNOSTIC_ORDER_STATE': 'DIAGNOSTIC_ORDER_INIT_DIAGNOSTIC_ORDER_STATE',
  'SET_DIAGNOSTIC_ORDER_CONFIG': 'DIAGNOSTIC_ORDER_SET_DIAGNOSTIC_ORDER_CONFIG',
  'UPDATE_DIAGNOSTIC_ORDER_FIELDS': 'DIAGNOSTIC_ORDER_FIELDS_UPDATE_BY_OBJECT',
  'SET_ALL_DIAGNOSTIC_ORDERS': 'DIAGNOSTIC_ORDER_SET_ALL_DIAGNOSTIC_ORDERS',
  'SET_NOTES': 'DIAGNOSTIC_ORDER_SET_NOTES',
  'SET_NOTES_CONTENT':'DIAGNOSTIC_ORDER_SET_NOTES_CONTENT',
  'SET_ORDERS_FOR_TEST_ALL_ITEMS':'SET_ORDERS_FOR_TEST_ALL_ITEMS'
};
